(function ($, njm) {
    'use strict';

    njm.views.clLogin = Backbone.View.extend({

        events: {
            'click #login1': 'login1',
            'click #login2': 'login2',
            'click #login4': 'updateQuestions',
            'click #cancel': 'backToSection',
            'click #cancelReset': 'cancelReset',
            'click #forgotAnswers': 'forgotAnswers',
            'click #login3': 'verifyCodeEvent',
            'click #createQuestionsCancel': 'backToSection',
            'click .password-visibility': 'passwordVisibility',
            'keypress #password': 'capslockHint',
            'click #forgotID': 'forgotID',
            'click #forgotPass': 'forgotPass',
            'click #register': 'register',
            'click #forgotIDBack': 'refresh',
            'click #forgotPassBack': 'refresh',
            'click #cancelResetPass': 'refresh',
            'click #cancelKba': 'refresh',
            'click #cancelReg': 'refresh',
            'click #cancelForgotID': 'refresh',
            'click #userIDConfirmBtn': 'refresh',
            'click #pwdConfirmBtn': 'refresh',
            'click #btnForgotID': 'forgotUserID',
            'click #btnForgotPass': 'forgotPassword',
            'click #btnPassQuestions': 'passQuestions',
            'click #btnIDQuestions': 'userIDQuestions',
            'click #createBack': 'backToQuestionsFromCreateBack',
            'click #cancelResetKba': 'backToQuestions',
            'click #login4Back': 'refresh'
        },

        initialize: function () {
            try {
                var checkUserUrl = $('#login3').data('checkuserurl'),
                    vercd = this.urlParam('vercd'),
                    user = this.urlParam('userid');
                const destinationUrl = $('#login1').data('destinationurl');
                // Check if in Experience Editor mode
                const isExperienceEditor = document.getElementById('hidIsExperienceEditor')?.value === "";
                const otpEntryVisible = $("#otp-entry").is(":visible");
                const urlObj = new URL(destinationUrl);
                const currentTimestamp = Date.now();
                const locCheck = decodeURIComponent(window.location.search);
                const gotoParam = this.urlParam('goto', locCheck);
                const dctimestamp = this.urlParam('_dc', locCheck);
                const dcTimeOut = 5 * 60 * 1000;// Timeout constant (5 minutes)
                const agentParam = this.urlParam("agent", locCheck);
                const customParam = this.urlParam('context', locCheck);
                if (isExperienceEditor && !otpEntryVisible) {
                    if (!gotoParam || !dctimestamp || (dctimestamp && (currentTimestamp - dctimestamp > dcTimeOut))) {
                        if (agentParam) {
                            agentParam === 'true' ? urlObj.searchParams.set('agent', true) : urlObj.searchParams.set('agent', false);
                        }
                        urlObj.searchParams.set('_dc', currentTimestamp);
                        if (customParam && customParam != '') {
                            urlObj.searchParams.set('context', customParam);
                        }
                        var processedUrl = decodeURIComponent(urlObj.toString());
                        njmClientClickTracking.trackRedirects(window.location.href, document.referrer, processedUrl);
                        this.redirect(processedUrl);
                    }
                    setInterval(function () {
                        if (!dctimestamp || (dctimestamp && (currentTimestamp - dctimestamp > dcTimeOut))) {
                            if (agentParam) {
                                agentParam === 'true' ? urlObj.searchParams.set('agent', true) : urlObj.searchParams.set('agent', false);
                            }
                            urlObj.searchParams.set('_dc', currentTimestamp);
                            if (customParam && customParam != '') {
                                urlObj.searchParams.set('context', customParam);
                            }
                            var processedUrl = decodeURIComponent(urlObj.toString());
                            njmClientClickTracking.trackRedirects(window.location.href, document.referrer, processedUrl);
                            this.redirect(processedUrl);
                        }
                    }, 300000);
                }
                if (vercd) {
                    this.verifyCode(vercd);
                } else {
                    if (user) {
                        $('#loading').show();
                        $.ajax({
                            type: 'POST',
                            url: checkUserUrl,
                            xhrFields: {
                                withCredentials: true
                            },
                            data: {
                                id: user
                            },
                            dataType: 'json',
                            success: function (response, status, request) {
                                document.getElementById("userid").value = response;
                                $('#loading').hide();
                            },
                            error: function (response) {
                                document.getElementById('warningText').innerHTML = "The link is expired. Please restart Forgot User ID process. ";
                                document.getElementById('warning').style.display = 'block';
                                $('#loading').hide();
                            }
                        });

                    }
                    $('#userid').keypress(function (e) {
                        if (e.keyCode === 13) {
                            $('#login1').click();
                        }
                    });
                    $('#password').keypress(function (e) {
                        if (e.keyCode === 13) {
                            $('#login1').click();
                        }
                    });
                    $('#ans1').keypress(function (e) {
                        if (e.keyCode === 13) {
                            $('#login2').click();
                        }
                    });
                    $('#ans2').keypress(function (e) {
                        if (e.keyCode === 13) {
                            $('#login2').click();
                        }
                    });
                }

                //if (localStorage.chkbox && localStorage.chkbox != '') {
                //    $('#rememberUserID').attr('checked', 'checked');
                //    $('#userid').val(localStorage.username);
                //} else {
                //    $('#rememberUserID').removeAttr('checked');
                //    $('#userid').val('');
                //}

                /**
                * Disable IE's capslock indicator since we provide one
                **/
                if ($('.cssLogin #password') && document.msCapsLockWarningOff === false) {
                    document.msCapsLockWarningOff = true;
                }

                /**
                * Prevent selecting duplicate security questions
                **/
                $(".security-question").change(function () {
                    var values = [];
                    $(".security-question").each(function () {
                        values.push(this.value);
                    });

                    $(this).siblings(".security-question").find("option").removeAttr("disabled").filter(function () {
                        var a = $(this).parent("select").val();
                        return (($.inArray(this.value, values) > -1) && (this.value != a))
                    }).attr("disabled", "disabled");
                });

                /**
                * Trigger prevention of duplicate security questions
                **/
                $(".security-question").eq(0).trigger('change');

                window.addEventListener("dd_response_unload", function () {
                    console.log("dd_response_unload event detected. Retrying Login.....");
                    $('#login1').click();
                });

                njmClientClickTracking.trackPageName(window.location.href, document.referrer);
            }
            catch (ex) {
                njmClientClickTracking.logErrorGeneric("initialize", ex.name, "Exception on initialize", "Anonymous", ex.stack);
                throw ex;
            }
        },

        stringTrim: function (x) {
            return x.replace(/^\s+|\s+$/gm, '');
        },

        /**
        * Parse return error message for Login
        **/
        checkLoginError: function (response) {
            var status = response.status,
                msg = response.responseText ? JSON.parse(response.responseText).message : '';
            var userId = this.stringTrim(document.getElementById('userid').value);
            var errorMsg = 'We’re sorry, an error has occurred. Please try again later.';

            if (status === 400 && msg) {
                if (msg.indexOf('Authentication Failed') >= 0) {
                    errorMsg = 'The User ID and/or Password you are entering are invalid.';
                    if (msg.indexOf('You will be locked out') >= 0) {
                        errorMsg = errorMsg + ' To avoid being locked out, please use the “Forgot User ID?” and/or “Forgot Password?” links to obtain your User ID or a new Password.';
                    }
                } else if (msg.indexOf('Your account has been locked') >= 0) {
                    errorMsg = 'You have been locked out of your account. Please contact our customer service department during our business hours.';
                } else if (msg.indexOf('Your account is locked') >= 0) {
                    errorMsg = 'Your account is locked. Please contact 888-374-2755 during our business hours.';
                } else if (msg.indexOf('You have not successfully completed your registration') >= 0) {
                    errorMsg = 'You have not successfully completed your registration. Please click the link in the e-mail we have sent you to complete the registration process or contact our Customer Service department during our business hours.';
                } else if (msg.indexOf('Your account has been deactivated') >= 0) {
                    errorMsg = 'Your account has been deactivated. Please contact our Customer Service department during our business hours.';
                } else {
                    errorMsg = 'The User ID and/or Password you are entering are invalid.';
                }
            }
            njmClientClickTracking.logErrorGeneric("checkLoginError", msg, status, userId, errorMsg);
            return errorMsg;
        },

        /**
        * Redirects to given location. Handles Cancel and Registration button clicks
        **/
        cancelReset: function (e) {
            var destinationUrl = $(e.currentTarget).data('href');
            var UserId = this.stringTrim(document.getElementById('userid').value);

            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);

            if (destinationUrl !== undefined && destinationUrl !== '') {
                window.location = destinationUrl;
            }
        },

        /**
        * In future, needs to get URL from API return in previous step as parameter
        **/
        redirect: function (inpurl) {
            if (window.location.search.indexOf('mobile=y') >= 0) {
                inpurl = inpurl + '?mobile=y';
            }
            window.location.replace(inpurl);
        },

        login1: function (e) {
            e.preventDefault();
            $('#loading').show();
            var UserId = this.stringTrim(document.getElementById('userid').value);

            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);

            var loginApiUrl = $(e.currentTarget).data('loginapiurl');
            var destinationUrl = $(e.currentTarget).data('destinationurl');

            this.login(loginApiUrl, destinationUrl, false);
        },

        /**
        * Passes question answers and save device choice to login/save API
        * Redirects on success
        **/
        login2: function (e) {
            e.preventDefault();
            var self = this;

            $('#loading').show();
            var UserId = this.stringTrim(document.getElementById('userid').value);
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);

            var ans1 = this.stringTrim(document.getElementById('ans1').value),
                ans2 = this.stringTrim(document.getElementById('ans2').value),
                valid = true;

            var loginApiUrl = $('#login1').data('loginapiurl');
            var destinationUrl = $('#login1').data('destinationurl');
            var saveApiUrl = $(e.currentTarget).data('saveapiurl');
            var OauthUrl = $(e.currentTarget).data('oauthurl');
            if (this.stringTrim(ans1) === '') {
                document.getElementById('ans1').style.border = '1px solid #cc0000';
                valid = false;
            } else {
                document.getElementById('ans1').style.border = '';
            }

            if (this.stringTrim(ans2) === '') {
                document.getElementById('ans2').style.border = '1px solid #cc0000';
                valid = false;
            } else {
                document.getElementById('ans2').style.border = '';
            }

            if (!valid) {
                document.getElementById('warningText').innerHTML = 'Please fill in the highlighted fields to continue';
                document.getElementById('warning').style.display = 'block';
                $('#loading').hide();
            } else {
                $.ajax({
                    type: 'POST',
                    url: saveApiUrl,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        'Answer1': this.stringTrim(document.getElementById('ans1').value),
                        'Answer2': this.stringTrim(document.getElementById('ans2').value),
                        'Save': document.getElementById('saveDevice').checked
                    },
                    success: function (response, status, request) {
                        document.getElementById('warning').style.display = 'none';
                        self.getOauthToken(destinationUrl, OauthUrl, self);
                    },
                    error: function (response) {
                        document.getElementById('ans1').value = '';
                        document.getElementById('ans2').value = '';
                        var error = self.checkKBAError(response.status, JSON.parse(response.responseText).message);
                        document.getElementById('warningText').innerHTML = error;
                        document.getElementById('warning').style.display = 'block';
                        $('#loading').hide();
                        if (error.indexOf('You have been locked out of your account.') < 0) {
                            self.login(loginApiUrl, destinationUrl, true);
                        }
                    }
                });
            }
        },

        login: function (loginApiUrl, destinationUrl, keepWarning) {
            var self = this;
            var destUrl = $('#login1').data('destinationurl');
            var OauthUrl = $('#login2').data('oauthurl');
            var blogReturnUrl = $('#login1').data('blogredirecturl');
            var userID = this.stringTrim(document.getElementById('userid').value),
                pass = this.stringTrim(document.getElementById('password').value),
                valid = true;
            //if (document.getElementById("rememberUserID").checked) {
            //    // save username and password
            //    localStorage.username = userID;
            //    localStorage.chkbox = document.getElementById("rememberUserID").checked;
            //} else {
            //    localStorage.username = '';
            //    localStorage.chkbox = '';
            //}
            if (this.stringTrim(userID) === '') {
                document.getElementById('userid').style.border = '1px solid #cc0000';
                valid = false;
            } else {
                document.getElementById('userid').style.border = '';
            }
            if (this.stringTrim(pass) === '') {
                document.getElementById('password').style.border = '1px solid #cc0000';
                valid = false;
            } else {
                document.getElementById('password').style.border = '';
            }

            if (!valid) {
                document.getElementById('warningText').innerHTML = 'Please fill in the highlighted fields to continue.';
                document.getElementById('warning').style.display = 'block';
                $('#loading').hide();
            } else {
                $.ajax({
                    type: 'POST',
                    url: loginApiUrl,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        'UserID': userID,
                        'Password': pass,
                        'device': device()
                    },
                    success: function (response, status, request) {

                        if (Array.isArray(response)) {
                            if (response.length == 2) {
                                document.getElementById("question1").innerHTML = response[0];
                                document.getElementById("question2").innerHTML = response[1];
                                document.getElementById("loginPage").style.display = "none";
                                if (!($("#loginPage").is(":visible"))) {
                                    $('.comp-login').addClass('hide-content');
                                }
                                document.getElementById("answerQuestions").style.display = "block";
                            }
                            else {
                                self.fillQuestions(response);
                                document.getElementById("loginPage").style.display = "none";
                                if (!($("#loginPage").is(":visible"))) {
                                    $('.comp-login').addClass('hide-content');
                                }
                                document.getElementById("createQuestions").style.display = "block";
                                document.getElementById("createBack").style.display = "none";

                            }
                        } else {
                            self.getOauthToken(destUrl, OauthUrl, self);
                        }
                        if (!keepWarning) {
                            document.getElementById('warning').style.display = 'none';
                        }
                        $('#loading').hide();
                    },
                    error: function (response) {
                        var errorResponse = self.checkLoginError(response);
                        document.getElementById('warningText').innerHTML = errorResponse;
                        document.getElementById('warning').style.display = 'block';
                        $('#loading').hide();
                        //if (!document.getElementById("rememberUserID").checked) {
                        //    document.getElementById('userid').value = '';
                        //}
                        document.getElementById('password').value = '';

                    }
                });
            }
        },

        /**
        * Parse return error message for KBA
        **/
        checkKBAError: function (status, msg) {
            var errorMsg = 'We’re sorry, an error has occurred. Please try again later.';
            var userId = this.stringTrim(document.getElementById('userid').value);
            if (status === 400) {
                if (msg.indexOf('Your account has been locked') >= 0) {
                    errorMsg = 'You have been locked out of your account. Please contact our customer service department during our business hours.';
                } else if (msg.indexOf('Your account is locked') >= 0) {
                    errorMsg = 'Your account is locked. Please contact 888-374-2755 during our business hours.';
                } else {
                    errorMsg = 'The answers you have entered do not match our records. Please try again.';
                    var index = msg.indexOf('You will be locked out');
                    if (index >= 0) {
                        errorMsg = errorMsg + ' ' + msg.substring(index);
                    }
                }
            }
            njmClientClickTracking.logErrorGeneric("checkKBAError", msg, status, userId, errorMsg);
            return errorMsg;
        },

        /**
        * Calls API to send email with code to enter and brings up enter code page
        **/
        forgotAnswers: function (e) {
            var inpurl = $('#forgotAnswers').data('forgotanswersapiurl');
            var UserId = this.stringTrim(document.getElementById('userid').value);
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);

            $.ajax({
                type: 'POST',
                url: inpurl,
                xhrFields: {
                    withCredentials: true
                },
                data: "=" + this.stringTrim(document.getElementById('userid').value),
                success: function (response, status, request) {
                    document.getElementById("warning").style.display = "none";
                    document.getElementById("answerQuestions").style.display = "none";
                    document.getElementById("enterCode").style.display = "block";
                    $('#loading').hide();
                },
                error: function (response) {
                    document.getElementById("ans1").value = '';
                    document.getElementById("ans2").value = '';
                    if (response.responseText.indexOf('locked') >= 0) {
                        var adminIndex = response.responseJSON.message.indexOf('admin');
                        if (adminIndex >= 0) {
                            var admin = response.responseJSON.message.substring(adminIndex + 7);

                            document.getElementById('warningText').innerHTML = 'You account is Locked. Please contact your Admin User ' + admin;
                        }
                        else {
                            document.getElementById('warningText').innerHTML = 'Your account is locked. Please contact 888-374-2755 during our business hours.';
                        }
                    }
                    else {
                        document.getElementById("warningText").innerHTML = 'We\'re sorry, an error has occurred. Please try again later.';
                    }
                    document.getElementById("warning").style.display = "block";
                    $('#loading').hide();
                }
            });
        },

        verifyCodeEvent: function (e) {
            var validateApiUrl = $('#login3').data('verifycodeapiurl');
            var destinationUrl = $('#login3').data('verifycodeDestinationurl');
            var self = this;
            var UserId = this.stringTrim(document.getElementById('userid').value);
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);

            this.verifyCode(validateApiUrl, destinationUrl, self);
        },

        /**
        * Sends entered code to API for verification and redirects to CSS if valid
        **/
        verifyCode: function (validateApiUrl, destinationUrl, self) {
            var self = this;
            $('#loading').show();
            if (document.getElementById("code").value == "") {
                document.getElementById("code").style.border = "1px solid #cc0000"
                document.getElementById("warningText").innerHTML = "Please fill in the highlighted field to continue";
                document.getElementById("warning").style.display = "block";
                $('#loading').hide();
            }
            else {
                $.ajax({
                    type: 'POST',
                    url: validateApiUrl,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        UserID: this.stringTrim(document.getElementById('userid').value),
                        Key: document.getElementById("code").value
                    },
                    success: function (response, status, request) {

                        document.getElementById("warning").style.display = "none";
                        $('#loading').hide();
                        self.fillQuestions(response);
                        document.getElementById("enterCode").style.display = "none";
                        document.getElementById("createQuestions").style.display = "block";
                        document.getElementById("code").value = '';
                        //redirect(destUrl);
                    },
                    error: function (response) {
                        var msg = response.responseText ? JSON.parse(response.responseText).message : '',
                            error = msg.indexOf('invalid') >= 0 ? 'The Validation Code you entered is not recognized. Please check the number and try again.' :
                                msg.indexOf('expired') >= 0 ? 'This Validation Code has expired. Please start the security question reset process again.' :
                                    'We\'re sorry, an error has occurred. Please try again later.';

                        document.getElementById("code").value = '';
                        document.getElementById("warningText").innerHTML = error;
                        document.getElementById("warning").style.display = "block";
                        $('#loading').hide();
                    }
                });
            }
        },

        /**
        * Calls API to update questions and redirects to portal if successful
        **/
        updateQuestions: function (e) {
            var self = this;
            var inpurl = $('#login4').data('updatequestionsapiurl');
            var destUrl = $('#login4').data('updatequestionsdestinationurl');
            $('#loading').show();
            var kba1 = document.getElementById("kba1").value,
                kba2 = document.getElementById("kba2").value,
                kba3 = document.getElementById("kba3").value,
                valid = true;
            var UserId = this.stringTrim(document.getElementById('userid').value);
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);

            if (this.stringTrim(kba1) == "") {
                document.getElementById("kba1").style.border = "1px solid #cc0000";
                valid = false;
            }
            else {
                document.getElementById("kba1").style.border = "";
            }

            if (this.stringTrim(kba2) == "") {
                document.getElementById("kba2").style.border = "1px solid #cc0000";
                valid = false;
            }
            else {
                document.getElementById("kba2").style.border = "";
            }

            if (this.stringTrim(kba3) == "") {
                document.getElementById("kba3").style.border = "1px solid #cc0000";
                valid = false;
            }
            else {
                document.getElementById("kba3").style.border = "";
            }

            if (!valid) {
                document.getElementById("warningText").innerHTML = " This is a required field. Please select a question or enter your answer.";
                document.getElementById("warning").style.display = "block";
                $('#loading').hide();
            }

            else if (this.validateAnswers()) {
                $.ajax({
                    type: 'POST',
                    xhrFields: {
                        withCredentials: true
                    },
                    url: inpurl,
                    data: {
                        UserID: this.stringTrim(document.getElementById('userid').value),
                        Answer1: this.stringTrim(document.getElementById("answer1").value),
                        Answer2: this.stringTrim(document.getElementById("answer2").value),
                        Answer3: this.stringTrim(document.getElementById("answer3").value),
                        Question1: this.stringTrim(document.getElementById("kba1").value),
                        Question2: this.stringTrim(document.getElementById("kba2").value),
                        Question3: this.stringTrim(document.getElementById("kba3").value)
                    },
                    success: function (response, status, request) {
                        document.getElementById("warning").style.display = "none";
                        document.getElementById("createQuestions").style.display = "none";
                        document.getElementById("updateConfirmation").style.display = "block";
                        $('#loading').hide();
                    },
                    error: function (response) {
                        document.getElementById("answer3").value = '';
                        document.getElementById("answer2").value = '';
                        document.getElementById("answer1").value = '';
                        document.getElementById("kba3").value = '';
                        document.getElementById("kba2").value = '';
                        document.getElementById("kba1").value = '';
                        document.getElementById("warningText").innerHTML = 'We\'re sorry, an error has occurred. Please try again later.';
                        document.getElementById("warning").style.display = "block";
                        $('#loading').hide();
                    }
                });
            }
        },

        areUniqueAnswers: function () {
            var isValid = true;

            var answer1 = this.stringTrim(document.getElementById('answer1').value),
                answer2 = this.stringTrim(document.getElementById('answer2').value),
                answer3 = this.stringTrim(document.getElementById('answer3').value);

            this.toggleErrorBorder('answer1', false);
            this.toggleErrorBorder('answer2', false);
            this.toggleErrorBorder('answer3', false);

            if (answer1 === answer2) {
                this.toggleErrorBorder('answer1', true);
                this.toggleErrorBorder('answer2', true);
                isValid = false;
            }

            if (answer1 === answer3) {
                this.toggleErrorBorder('answer1', true);
                this.toggleErrorBorder('answer3', true);
                isValid = false;
            }

            if (answer2 === answer3) {
                this.toggleErrorBorder('answer2', true);
                this.toggleErrorBorder('answer3', true);
                isValid = false;
            }

            return isValid;
        },

        /**
        * Validate answers are not the same, not part of question and in proper format
        * Returns true if they are and false otherwise
        * Updates warning message if needed
        **/
        validateAnswers: function () {

            if (!this.areUniqueAnswers()) {
                document.getElementById('warningText').innerHTML = 'Each security question must have a unique answer.';
                document.getElementById('warning').style.display = 'block';
                $('#loading').hide();
                return false;
            }

            var answer1 = this.stringTrim(document.getElementById('answer1').value),
                answer2 = this.stringTrim(document.getElementById('answer2').value),
                answer3 = this.stringTrim(document.getElementById('answer3').value);

            //check if answers are valid formatting
            var regex = /^[0-9a-zA-Z]{3,25}$/, valid = true;
            if (!regex.test(answer1)) {
                this.toggleErrorBorder('answer1', true);
                valid = false;
            } else {
                this.toggleErrorBorder('answer1', false);
            }

            if (!regex.test(answer2)) {
                this.toggleErrorBorder('answer2', true);
                valid = false;
            } else {
                this.toggleErrorBorder('answer2', false);
            }

            if (!regex.test(answer3)) {
                this.toggleErrorBorder('answer3', true);
                valid = false;
            } else {
                this.toggleErrorBorder('answer3', false);
            }

            if (!valid) {
                document.getElementById('warningText').innerHTML = 'Each answer must be 3-25 characters in length and must only use numeric characters (0-9) and/or alphabetic characters (a-z, A-Z).';
                document.getElementById('warning').style.display = 'block';
                $('#loading').hide();

                return false;
            }

            //check if answer is part of question
            var question, markInvalid = false;
            for (var i = 1; i <= 3; i++) {
                question = $('#kba' + i + ' option:selected').text().toLowerCase().split(' ');
                var answer = document.getElementById('answer' + i).value.toLowerCase();

                for (var j = 0; j < question.length; j++) {
                    if (question[j].indexOf(answer) >= 0) {
                        document.getElementById('answer' + i).style.border = '1px solid #cc0000';
                        valid = false;
                        markInvalid = true;
                        break;
                    }
                }

                if (!markInvalid) {
                    document.getElementById('answer' + i).style.border = '';
                }
            }

            if (!valid) {
                document.getElementById('warningText').innerHTML = 'Your answer cannot contain wording from the security question.';
                document.getElementById('warning').style.display = 'block';
                $('#loading').hide();

                return false;
            }

            return true;
        },

        toggleErrorBorder: function (field, toggle) {
            if (toggle) {
                document.getElementById(field).style.border = '1px solid #cc0000';
            }
            else {
                document.getElementById(field).style.border = '';
            }
        },

        /**
        * Fill questions select boxes
        **/
        fillQuestions: function (questions) {
            var question, opt;

            for (var i = 1; i <= 3; i++) {
                question = document.getElementById('kba' + i);
                for (var j = 0; j < questions.length; j++) {
                    opt = document.createElement('option');
                    opt.innerHTML = questions[j].text;
                    opt.value = questions[j].number;
                    question.appendChild(opt);
                }
            }
        },

        removeDisabledFromOptions: function (e) {
            var question, opt;

            for (var i = 1; i <= 3; i++) {
                question = document.getElementById('kba' + i);
                for (var j = 0; j < question.options.length; j++) {
                    question.options[j].removeAttribute('disabled')
                }
            }
        },


        backToSection: function (e) {
            var backSection = $(e.currentTarget).data('backsection');
            var currentSection = $(e.currentTarget).data('currentsection');

            if (backSection === 'login-box') {
                this.cancelReset(e);
                return;
            }
            var UserId = this.stringTrim(document.getElementById('userid').value);
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);

            document.getElementById("warning").style.display = "none";
            document.getElementById(currentSection).style.display = "none";
            document.getElementById(backSection).style.display = "block";
        },

        passwordVisibility: function (e) {
            var self = e.currentTarget;
            var UserId = this.stringTrim(document.getElementById('userid').value);
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);

            if ($(self).text() === 'Show') {
                $('.cssLogin input#password').attr('type', 'text');
                $(self).text('Hide');
            } else {
                $('.cssLogin input#password').attr('type', 'password');
                $(self).text('Show');
            }
        },

        isCapsLockOn: function (e) {
            if (e.originalEvent.getModifierState("CapsLock")) {
                return true;
            } else {
                return false;
            }
        },

        forgotID: function (e) {
            document.getElementById('loginDiv').style.display = 'none';
            document.getElementById('userIDDiv').style.display = 'block';
            if (!($("#loginDiv").is(":visible"))) {
                $('.comp-login').addClass('hide-content');
            }
        },

        forgotPass: function (e) {
            document.getElementById('loginDiv').style.display = 'none';
            document.getElementById('pwdDiv').style.display = 'block';
            if (!($("#loginDiv").is(":visible"))) {
                $('.comp-login').addClass('hide-content');
            }
        },
        register: function (e) {
            document.getElementById('loginDiv').style.display = 'none';
            document.getElementById('regDiv').style.display = 'block';
        },

        refresh: function (e) {
            var UserId = document.getElementById('userid').value;
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);

            location.reload();
        },

        urlParam: function (name, param) {
            var paramCheck;
            name = name.toLowerCase();
            if (!param) {
                var location = window.location.search,
                    index = location.indexOf('=');
                paramCheck = location.substring(0, index).toLowerCase() + location.substring(index);
            }
            else paramCheck = param;
            var results = new RegExp('[\?&]' + name + '=([^&#]*)')
                .exec(paramCheck);
            return (results !== null) ? results[1] || 0 : false;
        },
        getUrlParameter: function (name, search, encodeResult) {
            search = search || window.location.search;
            var params = new URLSearchParams(search);
            var param = params.get(name) || '';
            if (encodeResult) {
                param = encodeURIComponent(param);
            }
            return param;
        },

        getOriginalRequestQueryString: function () {
            var val = this.getUrlParameter('original_request_url');
            try {
                var url = new URL(val);
                return url.search;
            }
            catch (e) {
                console.error(e);
                return '';
            }
        },
        forgotUserID: function (e) {
            $('#loading').show();
            var UserId = this.stringTrim(document.getElementById('txtUserIDEmail').value);
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);
            
            var forgotUserIdApiUrl = $('#btnForgotID').data('forgotuseridapiurl');
            var email = document.getElementById('txtUserIDEmail').value,
                regex = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*(\ )*$/;

            document.getElementById("txtUserIDEmail").style.border = "";

            if (email == '') {
                document.getElementById("txtUserIDEmail").style.border = "1px solid #cc0000";
                document.getElementById('userIDWarningText').innerHTML = document.getElementById('hidForgotUserIDEmptyEmail').value;
                //document.getElementById('userIDWarningText').innerHTML = 'This field is required, please select or enter a valid email address';
                document.getElementById('userIDWarning').style.display = 'block';
                $('#loading').hide();
                return;
            }

            if (!regex.test(email)) {
                document.getElementById("txtUserIDEmail").style.border = "1px solid #cc0000";
                document.getElementById('userIDWarningText').innerHTML = document.getElementById('hidForgotUserIDInvalidEmail').value;
                //document.getElementById('userIDWarningText').innerHTML = 'You must enter a valid email address.';
                document.getElementById('userIDWarning').style.display = 'block';
                $('#loading').hide();
                return;
            }

            $.ajax({
                type: 'POST',
                url: forgotUserIdApiUrl,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    id: email
                },
                dataType: 'json',
                success: function (response, status, request) {
                    document.getElementById('userIDWarning').style.display = 'none';

                    if (response.indexOf('multiple') >= 0) {
                        document.getElementById('userIDWarningText').innerHTML = 'The email address has multiple users. Please contact us  at 1-888-NJM-4INS ext. 6683 or at wcedit@njm.com to retrieve your User ID.';
                        document.getElementById('userIDWarning').style.display = 'block';
                    }
                    else {
                        document.getElementById("idQuestion1").innerHTML = response[0];
                        document.getElementById("idQuestion2").innerHTML = response[1];
                        document.getElementById('userIDQuestions').style.display = 'block';
                        document.getElementById('userIDPage').style.display = 'none';
                    }
                    $('#loading').hide();
                },
                error: function (response) {
                    if (response.responseText.indexOf('Not found') >= 0) {
                        document.getElementById('userIDWarningText').innerHTML = 'Not Found';
                    }
                    else if (response.responseText.indexOf('locked') >= 0) {
                        var adminIndex = response.responseJSON.message.indexOf('admin');
                        if (adminIndex >= 0) {
                            var admin = response.responseJSON.message.substring(adminIndex + 7);

                            document.getElementById('userIDWarningText').innerHTML = 'You account is Locked. Please contact your Admin User ' + admin;
                        }
                        else {
                            document.getElementById('userIDWarningText').innerHTML = 'Your account is locked. Please contact 888-374-2755 during our business hours.';
                        }
                    }
                    else if (response.responseText.indexOf('have not successfully completed your registration') >= 0) {
                        document.getElementById('userIDWarningText').innerHTML = 'This feature is not available as you have not successfully completed your registration. Please click the link in the e-mail we have sent you to complete the registration process or contact our Customer Service department during our business hours.'
                    }
                    else {
                        document.getElementById('userIDWarningText').innerHTML = 'We\'re sorry, an error has occurred. Please try again later.';
                    }
                    document.getElementById('userIDWarning').style.display = 'block';
                    $('#loading').hide();
                }
            });
        },

        forgotPassword: function (e) {
            $('#loading').show();
            var forgotPassUrl = $('#btnForgotPass').data('forgotpassurl');
            var user = this.stringTrim(document.getElementById('txtPassUserID').value);

            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, user);

            document.getElementById("txtPassUserID").style.border = "";

            if (user == '') {
                document.getElementById("txtPassUserID").style.border = "1px solid #cc0000";
                document.getElementById('passWarningText').innerHTML = 'Enter User ID';
                document.getElementById('passWarning').style.display = 'block';
                $('#loading').hide();
                return;
            }
            $.ajax({
                type: 'POST',
                url: forgotPassUrl,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    id: user
                },
                dataType: 'json',
                success: function (response, status, request) {
                    document.getElementById('passWarning').style.display = 'none';
                    document.getElementById("passQuestion1").innerHTML = response[0];
                    document.getElementById("passQuestion2").innerHTML = response[1];
                    document.getElementById('passQuestions').style.display = 'block';
                    document.getElementById('passPage').style.display = 'none';
                    $('#loading').hide();
                },
                error: function (response) {
                    if (response.responseText.indexOf('cannot be found') >= 0) {
                        document.getElementById('passWarningText').innerHTML = 'Your request was submitted. If the User ID exists, an email was sent to the email address on record for the account.';
                    }
                    else if (response.responseJSON.message.indexOf('Invalid request') >= 0) {
                        document.getElementById('passWarningText').innerHTML = 'The User ID you entered doesn\'t match our records. Please try again';
                    }
                    else if (response.responseText.indexOf('locked') >= 0) {
                        var adminIndex = response.responseJSON.message.indexOf('admin');
                        if (adminIndex >= 0) {
                            var admin = response.responseJSON.message.substring(adminIndex + 7);

                            document.getElementById('passWarningText').innerHTML = 'You account is Locked. Please contact your Admin User ' + admin;
                        }
                        else {
                            document.getElementById('passWarningText').innerHTML = 'Your account is locked. Please contact 888-374-2755 during our business hours.';
                        }
                    }
                    else if (response.responseText.indexOf('have not successfully completed your registration') >= 0) {
                        document.getElementById('passWarningText').innerHTML = 'This feature is not available as you have not successfully completed your registration. Please click the link in the e-mail we have sent you to complete the registration process or contact our Customer Service department during our business hours.'
                    }
                    else {
                        document.getElementById('passWarningText').innerHTML = 'We\'re sorry, an error has occurred. Please try again later.';
                    }
                    document.getElementById('passWarning').style.display = 'block';
                    $('#loading').hide();
                }
            });


        },

        getOauthToken: function (destUrl, OauthUrl, self) {

            var goto = decodeURIComponent(location.href.substr(location.href.indexOf('agent'))).replace("#", "%20%25");
            var redirectUrl = OauthUrl + goto + "&realm=/B2C_Admin/CLPORTAL_Admin/CLPORTAL_Users";
            var blogReturnUrl = $('#login1').data('blogredirecturl');
            if (blogReturnUrl.trim().length != 0 && self.stringTrim(blogReturnUrl) != '') {
                if (blogReturnUrl.indexOf("?") > 0) {
                    self.redirect(blogReturnUrl + "&returnUrl=" + encodeURIComponent(redirectUrl));
                }
                else {
                    self.redirect(blogReturnUrl + "?returnUrl=" + encodeURIComponent(redirectUrl));
                }
            }
            else {
                self.redirect(redirectUrl);
            }


            //var self = this;
            //$.ajax({
            //    type: 'POST',
            //    url: OauthUrl,
            //    xhrFields: {
            //        withCredentials: true
            //    },
            //    dataType: 'json',
            //    success: function (response, status, request) {
            //        document.getElementById("warning").style.display = "none";
            //        console.log(response);
            //        console.log(response.token);
            //        console.log(response.state);
            //        var data = response;
            //        self.amOauth(response.token, response.state, destUrl, self);
            //        $('#loading').hide();
            //    },
            //    error: function (response) {
            //        document.getElementById("warningText").innerHTML = "There was an error";
            //        document.getElementById("warning").style.display = "block";
            //        $('#loading').hide();
            //    }
            //});
        },

        //amOauth: function (token, state, destUrl, self) {
        //    if (!token || !state) {
        //        $('#loading').hide();
        //        document.getElementById('warningText').innerHTML = 'There was an error';
        //        document.getElementById('warning').style.display = 'block';
        //        return;
        //    }

        //    $.ajax({
        //        type: 'POST',
        //        url: 'https://clportalqa2.njm.com/agent/cdsso-oauth2',
        //        xhrFields: {
        //            withCredentials: true
        //        },
        //        data: {
        //            'id_token': token, 'state': state
        //        },
        //        dataType: 'json',
        //        complete: function (response, status, request) {
        //            document.getElementById("warning").style.display = "none";
        //            $('#loading').hide();
        //            self.redirect(destUrl);
        //        },
        //        error: function (response) {
        //        }
        //    });
        //},

        passQuestions: function (e) {
            $('#loading').show();
            var answer1 = document.getElementById('passAns1').value,
                answer2 = document.getElementById('passAns2').value,
                valid = true,
                forgotPassQuestionsUrl = $('#btnPassQuestions').data('forgotpassquestions');
            var UserId = document.getElementById('txtPassUserID').value;
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);

            document.getElementById("passAns1").style.border = "";
            document.getElementById("passAns2").style.border = "";

            if (answer1 == '') {
                document.getElementById("passAns1").style.border = "1px solid #cc0000";
                valid = false;
            }

            if (answer2 == '') {
                document.getElementById("passAns2").style.border = "1px solid #cc0000";
                valid = false;
            }

            if (!valid) {
                document.getElementById('passWarningText').innerHTML = 'This field is required, please enter a value';
                document.getElementById('passWarning').style.display = 'block';
                $('#loading').hide();
                return;
            }

            $.ajax({
                type: 'POST',
                url: forgotPassQuestionsUrl,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    'Answer1': answer1,
                    'Answer2': answer2
                },
                dataType: 'json',
                success: function (response, status, request) {
                    $('#loading').hide();
                    document.getElementById('passWarning').style.display = 'none';
                    document.getElementById('pwdConfirm').style.display = 'block';
                    document.getElementById('passQuestions').style.display = 'none';
                },
                error: function (response) {
                    var text = response.responseJSON.message ? response.responseJSON.message : "";
                    if (text.indexOf('not matched') >= 0) {
                        document.getElementById('passWarningText').innerHTML = text.replace('Answers are not matched', 'The answers you have entered do not match our records.  Please try again');
                    }
                    else {
                        document.getElementById('passWarningText').innerHTML = 'We\'re sorry, an error has occurred. Please try again later.';
                    }
                    document.getElementById('passWarning').style.display = 'block';
                    $('#loading').hide();
                }
            });

            //jQuery.post(forgotPassQuestionsUrl, { Answer1: answer1, Answer2: answer2 }, function (response) {
            //    $('#loading').hide();
            //    window.location.replace('/clauth/Pages/EmailSent.html?page=pass');
            //}).fail(function (response) {
            //    $('#loading').hide();
            //    var text = response.responseJSON.message ? response.responseJSON.message : "";
            //    if (text.indexOf('not matched') >= 0) {
            //        document.getElementById('passWarningText').innerHTML = text.replace('Answers are not matched', 'The answers you have entered do not match our records');
            //    }
            //    else {
            //        document.getElementById('passWarningText').innerHTML = 'We\'re sorry, an error has occurred. Please try again later.';
            //    }
            //    document.getElementById('passWarning').style.display = 'block';
            //    $('#loading').hide();
            //});
        },

        userIDQuestions: function (e) {
            $('#loading').show();
            var answer1 = document.getElementById('idAns1').value,
                answer2 = document.getElementById('idAns2').value,
                valid = true,
                url = $('#btnIDQuestions').data('forgotidquestionsapiurl');
            document.getElementById("idAns1").style.border = "";
            document.getElementById("idAns2").style.border = "";
            var UserId = document.getElementById('txtUserIDEmail').value;
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);

            if (answer1 == '') {
                document.getElementById("idAns1").style.border = "1px solid #cc0000";
                valid = false;
            }

            if (answer2 == '') {
                document.getElementById("idAns2").style.border = "1px solid #cc0000";
                valid = false;
            }

            if (!valid) {
                document.getElementById('userIDWarningText').innerHTML = 'This field is required, please enter a value.';
                document.getElementById('userIDWarning').style.display = 'block';
                $('#loading').hide();
                return;
            }
            $.ajax({
                type: 'POST',
                url: url,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    'Answer1': answer1,
                    'Answer2': answer2
                },
                dataType: 'json',
                success: function (response, status, request) {
                    $('#loading').hide();
                    document.getElementById('userIDWarning').style.display = 'none';
                    document.getElementById('userIDConfirm').style.display = 'block';
                    document.getElementById('userIDQuestions').style.display = 'none';
                    //window.location.replace('/clauth/Pages/EmailSent.html');
                },
                error: function (response) {
                    $('#loading').hide();
                    var text = response.responseJSON.message ? response.responseJSON.message : "";
                    if (text.indexOf('not matched') >= 0) {
                        document.getElementById('userIDWarningText').innerHTML = text.replace('Answers are not matched', 'The answers you have entered do not match our records.  Please try again');
                    }
                    else {
                        document.getElementById('userIDWarningText').innerHTML = 'We\'re sorry, an error has occurred. Please try again later.';
                    }
                    document.getElementById('userIDWarning').style.display = 'block';
                    $('#loading').hide();
                }
            });
            //jQuery.post(url, { Answer1: answer1, Answer2: answer2 }, function (response) {
            //    $('#loading').hide();
            //    window.location.replace('/clauth/Pages/EmailSent.html');
            //}).fail(function (response) {
            //    $('#loading').hide();
            //    var text = response.responseJSON.message ? response.responseJSON.message : "";
            //    if (text.indexOf('not matched') >= 0) {
            //        document.getElementById('userIDWarningText').innerHTML = text.replace('Answers are not matched', 'The answers you have entered do not match our records');
            //    }
            //    else {
            //        document.getElementById('userIDWarningText').innerHTML = 'We\'re sorry, an error has occurred. Please try again later.';
            //    }
            //    document.getElementById('userIDWarning').style.display = 'block';
            //    $('#loading').hide();
            //});
        },

        backToQuestions: function (e) {
            document.getElementById("warning").style.display = "none";
            document.getElementById("enterCode").style.display = "none";
            document.getElementById("answerQuestions").style.display = "block";
        },


        backToQuestionsFromCreateBack: function (e) {
            document.getElementById("kba1").selectedIndex = 0;
            document.getElementById("kba2").selectedIndex = 0;
            document.getElementById("kba3").selectedIndex = 0;
            document.getElementById('answer1').value = '';
            document.getElementById('answer2').value = '';
            document.getElementById('answer3').value = '';
            this.removeDisabledFromOptions();
            document.getElementById("warning").style.display = "none";
            document.getElementById("createQuestions").style.display = "none";
            document.getElementById("answerQuestions").style.display = "block";
        },

        capslockHint: function (e) {
            if (this.isCapsLockOn(e) && ($('#warning').css('display') === 'block')) {
                $(".capslock-hint").css('display', 'inline-block');
            } else {
                $(".capslock-hint").css('display', 'none');
            }
        }
    });
})(jQuery, njm);
